import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">DCSkateMarket · Your Skateboarding Hub</p>
        <h1>Welcome to DCSkateMarket!</h1>
        <p className="lede">
          Discover the ultimate destination for all your skateboarding needs. From gear to apparel, we have everything to elevate your ride.
        </p>
        <div className="cta-row">
          <a href="/shop" target="_blank">
            Shop Now
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Explore Our Collection</h2>
          <p>
            Browse through a wide range of skateboards, accessories, and apparel designed for skaters of all levels.
          </p>
        </article>
        <article>
          <h2>Join Our Community</h2>
          <p>
            Connect with fellow skate enthusiasts, share tips, and participate in local events to enhance your skating experience.
          </p>
        </article>
        <article>
          <h2>Stay Updated</h2>
          <p>
            Sign up for our newsletter to receive the latest news, product launches, and exclusive offers right in your inbox.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;